import { defineMessages } from 'react-intl';

const graphQLErrorMessages = defineMessages({
  ERR_GENERIC: {
    id: 'error_generic',
    defaultMessage: 'Something went wrong. Please try again.'
  },
  ERR_NETWORK_ERROR: {
    id: 'graphQLErrors.ERR_NETWORK_ERROR',
    defaultMessage:
      'Ouch, could not contact the other end. Do you have an internet connection?'
  },
  ERR_INVALID_PHONE_NUMBER: {
    id: 'graphQLErrors.ERR_INVALID_PHONE_NUMBER',
    defaultMessage: 'Invalid phone number entered.'
  },
  ERR_UNKNOWN_PHONE_NUMBER: {
    id: 'graphQLErrors.ERR_UNKNOWN_PHONE_NUMBER',
    defaultMessage: 'The number does not exist. Check spelling and try again.'
  },
  ERR_INVALID_PHONE_VERIFICATION_CODE: {
    id: 'graphQLErrors.ERR_INVALID_PHONE_VERIFICATION_CODE',
    defaultMessage: 'Sorry, the code entered is incorrect.'
  },
  ERR_IN_USE_PHONE_NUMBER: {
    id: 'graphQLErrors.ERR_IN_USE_PHONE_NUMBER',
    defaultMessage: 'Sorry, the number is already in use.'
  },
  ERR_VALUE_CODE_EXPIRED: {
    id: 'graphQLErrors.ERR_VALUE_CODE_EXPIRED',
    defaultMessage: 'This code has expired.'
  },
  ERR_VALUE_CODE_USED: {
    id: 'graphQLErrors.ERR_VALUE_CODE_USED',
    defaultMessage: 'Ouch! This code has already been used.'
  },
  ERR_VALUE_CODE_NO_LONGER_AVAILABLE: {
    id: 'graphQLErrors.ERR_VALUE_CODE_NO_LONGER_AVAILABLE',
    defaultMessage: 'This voucher code is no longer available.'
  },
  ERR_VALUE_CODE_ACCOUNT_ALREADY_HAS_SUBSCRIPTION: {
    id: 'graphQLErrors.ERR_VALUE_CODE_ACCOUNT_ALREADY_HAS_SUBSCRIPTION',
    defaultMessage: 'Your account has an active subscription already.'
  },
  ERR_VALUE_CODE_UNKNOWN: {
    id: 'platform_error_value_code_unknown',
    defaultMessage:
      'We could not find this code. Check that the code you entered is correct.'
  },
  ERR_PAYMENT_DECLINED: {
    id: 'platform_error_purchase_declined',
    defaultMessage: 'Oops! The payment was declined.'
  },
  ERR_PAYMENT_ERROR: {
    id: 'error_payment_default',
    defaultMessage: 'Oops! Something went wrong with your payment.'
  },
  ERR_USER_NO_AGREEMENT: {
    id: 'graphQLErrors.ERR_USER_NO_AGREEMENT',
    defaultMessage: 'User has no payment agreement'
  }
});

export default graphQLErrorMessages;
